import { PropsWithChildren, ReactNode } from "react";

import { TableData } from "~/common/components";

interface RawResponseLayout extends PropsWithChildren {
  question?: ReactNode;
}

export const RawResponseLayout = ({
  question,
  children,
}: RawResponseLayout) => {
  if (!question || !children) return null;
  return (
    <tr className="border-b border-gray-300 py-4 last:border-none">
      <TableData className="flex flex-col items-start px-4 text-start first-letter:uppercase">
        <p className="first-letter:uppercase">{question}</p>
      </TableData>
      <TableData className="px-4 first-letter:uppercase">{children}</TableData>
    </tr>
  );
};
